import { useCallback } from 'react';
import { pick } from 'js/utils/ramda.util';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as server from '../server';
import * as helpers from '../helpers';
import * as actions from '../store/actions';
import { DEFAULT_PAGE_SIZE, LAST_SIX_MONTHS_VALUE } from '../constants';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../store';

export const useFetchSportsbookGamingHistory = () => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const translate = useComponentTranslations();
    const {
        period, page: { pageId, secondBulk }, startDate, endDate, isPreventFetchByAnotherPeriod
    } = useDynamicReducerSelector(pick([
        'period', 'page', 'startDate', 'endDate', 'isPreventFetchByAnotherPeriod'
    ]));

    return useCallback(() => {
        if (!isMounted() || isPreventFetchByAnotherPeriod) {
            return;
        }

        dispatch(actions.toggleLoading(true));
        dispatch(actions.setError({ error: '' }));

        const { requestStartDate, requestEndDate } = helpers.getRequestDates({ period, startDate, endDate });
        const isAutoFetchHistory = secondBulk && period === LAST_SIX_MONTHS_VALUE;
        const { startDate: startDateSecondBulk, endDate: endDateSecondBulk } = helpers.getSecondBulkForSixMonthsDates();

        (async () => {
            try {
                const {
                    data: { walletTransactions = [], pagerResponse = {}, defaultTypeNames = {} }
                } = await server.getSportsbookGamingHistory({
                    pageId: pageId || 0,
                    pageSize: DEFAULT_PAGE_SIZE,
                    endDate: isAutoFetchHistory ? endDateSecondBulk : requestEndDate,
                    startDate: isAutoFetchHistory ? startDateSecondBulk : requestStartDate
                });

                isMounted() && dispatch(actions.updateHistory({
                    transactions: walletTransactions,
                    pagerResponse,
                    defaultTypeNames
                }));
            } catch (error) {
                isMounted() && dispatch(actions.setError({ error: translate('error') }));
            } finally {
                isMounted() && dispatch(actions.toggleLoading(false));
            }
        })();

    }, [
        isMounted, isPreventFetchByAnotherPeriod, dispatch, period,
        startDate, endDate, secondBulk, pageId, translate
    ]);
};
